import React from "react";
import { Fragment } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import $ from "jquery";

import editbutton from "../../static/images/edit-button.svg";

const AboutUs = ({ company, reload, edit = true  }) => {
  // const [state, setstate] = useState(initialState);

  function GuardarAbout(values) {
    let perfil = {
      aboutUs: values.aboutUs,
      companyId: company.companyProfileId,
      employes: "",
      fundation: "",
      genderPoliciesUs: values.genderPoliciesUs,
      linkFacebook: "",
      linkInstagram: "",
      linkTwitter: "",
      mission: values.mission,
      name: "",
      sectorId: "",
      slogan: "",
      ubication: "",
      valuesUs: values.valuesUs,
      webSite: "",
    };

    axios.post("access/create-company-aboutus", perfil).then((result) => {
      if (result.status === 200) {
        toast.success("Se ha actualizado su perfil exitosamente", {
          duration: 6000,
        });
        $("#crear-acercade-modal").modal("hide");
        reload();
      }
    });
  }

  const Validaciones = Yup.object().shape({
    aboutUs: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(5000, "No puede tener mas de 60 caracteres"),
    genderPoliciesUs: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(5000, "No puede tener mas de 60 caracteres"),
    mission: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(5000, "No puede tener mas de 60 caracteres"),
    valuesUs: Yup.string()
      .required("No puede estar vacio")
      .min(3, "No puede tener menos de 3 caracteres")
      .max(5000, "No puede tener mas de 60 caracteres"),
  });

  return (
    <Fragment>
      <div className="vacancy__description bordered-box">
        <a
          href="#"
          data-bs-toggle="modal"
          data-bs-target="#crear-acercade-modal"
          data-title="Acerca de"
        >
          {edit ? (
            <img
              src={editbutton}
              alt="Editar Acerca de Nosotros"
              style={{ float: "right" }}
            ></img>
          ): null}
        </a>
        <div className="bordered-box__header">
          <div className="bordered-box__header-title">Acerca de Nosotros</div>
          <p>{company.aboutUs}</p>
        </div>
        <div className="bordered-box__body">
          <div className="bordered-box__header-title">Misión</div>
          <p>{company.mission}</p>
          <div className="bordered-box__header-title">Nuestros Valores</div>
          <p>{company.valuesUs}</p>
          <div className="bordered-box__header-title">
            Nuestras Políticas de Género
          </div>
          <p>{company.genderPoliciesUs}</p>
        </div>
      </div>

      <div
        id="crear-acercade-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          id="editAcerca"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-0">
              <div className="modal-title">Acerca de Nosotros</div>

              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <hr className="mb-5"></hr>

            <div className="form form--white ">
              <Formik
                initialValues={{
                  aboutUs: company?.aboutUs ?? "",
                  employes: "",
                  fundation: "",
                  genderPoliciesUs: company?.genderPoliciesUs ?? "",
                  linkFacebook: "",
                  linkInstagram: "",
                  linkTwitter: "",
                  mission: company?.mission ?? "",
                  name: "",
                  sectorId: 0,
                  slogan: "",
                  ubication: "",
                  valuesUs: company?.valuesUs ?? "",
                  webSite: "",
                }}
                onSubmit={(values, { setSubmitting }) => {
                  setSubmitting(true);
                  GuardarAbout(values);
                  setSubmitting(false);
                }}
                validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="div__wrapper">
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label>Acerca de Nosotros</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            as="textarea"
                            className="mt-0"
                            name="aboutUs"
                            required
                          ></Field>
                        </div>
                      </div>
                      {/* <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label className="mt-2">URL Video</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            type="text"
                            className="mt-0 pt-2 pb-2"
                            required
                          ></Field>
                        </div>
                      </div> 
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label className="mt-2">Subir una imagen</label>
                        </div>
                        <div className="col-sm-9">
                          <button className="uploadImg form-control">
                            <img
                              className="me-1"
                              src={UpImage}
                              alt="subir imagen"
                            ></img>
                            SUBIR
                          </button>
                        </div>
                      </div>*/}
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label htmlFor="genderPoliciesUs">
                            Políticas de Género
                          </label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            className="mt-0"
                            as="textarea"
                            name="genderPoliciesUs"
                            id="genderPoliciesUs"
                            required
                          ></Field>
                          {errors.genderPoliciesUs &&
                            touched.genderPoliciesUs && (
                              <span className="form__validation form__validation--error">
                                {errors.genderPoliciesUs}
                              </span>
                            )}
                        </div>
                      </div>
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label htmlFor="mission">Misión</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            className="mt-0"
                            type="text"
                            name="mission"
                            id="mission"
                            required
                          ></Field>
                          {errors.mission && touched.mission && (
                            <span className="form__validation form__validation--error">
                              {errors.mission}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label htmlFor="valuesUs">Valores</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            className="mt-0"
                            type="text"
                            name="valuesUs"
                            id="valuesUs"
                            required
                          ></Field>
                          {errors.valuesUs && touched.valuesUs && (
                            <span className="form__validation form__validation--error">
                              {errors.valuesUs}
                            </span>
                          )}
                        </div>
                      </div>
                      {/*<div className="row mb-4 form__row">
                        <div className="col-sm-3">
                          <label htmlFor="aboutUs">Acerca de mí</label>
                        </div>
                        <div className="col-sm-9">
                          <Field
                            className="mt-0"
                            as="textarea"
                            type="text"
                            name="aboutUs"
                            id="aboutUs"
                            required
                          ></Field>
                          {errors.aboutUs && touched.aboutUs && (
                            <span className="form__validation form__validation--error">
                              {errors.aboutUs}
                            </span>
                          )}
                        </div>
                          </div>*/}
                      <div className="row form__row">
                        <div className="modal-footer">
                          <button
                            // disabled={isSubmitting}
                            type="button"
                            data-bs-dismiss="modal"
                            className="btn btn--cancel btn__icon btn__icon--door"
                          >
                            Cancelar
                          </button>
                          <button
                            disabled={isSubmitting}
                            type="submit"
                            className="btn btn--purple btn__icon btn__icon--door"
                          >
                            Guardar
                          </button>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AboutUs;
